import Accordion from "@JohnLewisPartnership/jl-design-system/dist/components/accordion/Accordion";
import OpenInNew24PxOutlinedIcon from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/OpenInNew24PxOutlined";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import styles from "./BuyingGuidesAccordion.module.scss";
import { Link } from "../../../../types/prodcatBaseTypes";

type Props = {
  links: Link[];
  open: boolean | undefined;
};

export function BuyingGuidesAccordionUI({ links, open }: Props) {
  if (links.length < 1) {
    return null;
  }
  return (
    <Accordion
      className={styles["product-accordion__item"]}
      data-testid="accordion:buyingguides"
      label={"Useful guides"}
      animated={true}
      responsive
      open={open}
    >
      <ul className={styles.buyingGuides}>
        {links.map(({ linkUrl, text }) => (
          <li key={linkUrl} className={styles.buyingGuide}>
            <span className={styles.buyingGuideName}>{text}</span>
            {/* <a href={linkUrl} target="_blank" rel="noreferrer">
              View the guide
              <OpenInNew24PxOutlinedIcon />
            </a> */}
            <UnderlinedButton
              className={styles.externalButton}
              tag="a"
              target="_blank"
              rel="noreferrer"
              href={linkUrl}
            >
              View the guide
              <OpenInNew24PxOutlinedIcon />
            </UnderlinedButton>
          </li>
        ))}
      </ul>
    </Accordion>
  );
}
